import { call, put, takeLatest, select } from 'redux-saga/effects';
import {
  FETCH_PENDING_CONTENTS_REQUEST,
  APPROVE_CONTENT_REQUEST,
  REJECT_CONTENT_REQUEST
} from './_actionTypes';
import {
  fetchPendingContentsSuccess,
  fetchPendingContentsFailure,
  approveContentSuccess,
  approveContentFailure,
  rejectContentSuccess,
  rejectContentFailure,
  fetchPendingContentsRequest
} from './_actions';
import API_ENDPOINTS from '../../../../utils/API/endpoints';
import ApiHelper from '../../../../utils/API/ApiHelper';

// Saga workers
function* fetchPendingContentsSaga(action) {
  try {
    const filters = action.payload;
    const params = new URLSearchParams();
    
    if (filters.courseId) params.append('courseId', filters.courseId);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);

    const endpoint = `${API_ENDPOINTS.ADMIN.CONTENT_PENDING_APPROVALS}?${params.toString()}`;
    const response = yield call(ApiHelper.get, endpoint);

    console.log('API Response:', response);

    if (response.success) {
      const transformedData = (response.data?.data || []).map(content => ({
        ...content,
        sme: content.submitted_user ? {
          id: content.submitted_user.id,
          name: `${content.submitted_user.first_name} ${content.submitted_user.last_name}`.trim()
        } : null
      }));

      const payload = {
        data: transformedData,
        pagination: response.data?.pagination || {
          currentPage: 1,
          totalPages: 1,
          totalItems: 0,
          itemsPerPage: 20
        }
      };
      
      console.log('Dispatching payload:', payload);
      yield put(fetchPendingContentsSuccess(payload));
    } else {
      yield put(fetchPendingContentsFailure(response.message || 'Failed to fetch pending contents'));
    }
  } catch (error) {
    console.error('Unexpected error in fetchPendingContentsSaga:', error);
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch pending contents';
    yield put(fetchPendingContentsFailure(errorMessage));
  }
}

function* approveContentSaga(action) {
  try {
    const contentId = action.payload;
    const endpoint = API_ENDPOINTS.ADMIN.CONTENT_APPROVE(contentId);
    const response = yield call(ApiHelper.post, endpoint, {});

    if (response.success) {
      yield put(approveContentSuccess(contentId));
      
      const filters = yield select(state => state.contentApproval.filters);
      yield put(fetchPendingContentsRequest(filters));
    } else {
      yield put(approveContentFailure(response.message || 'Failed to approve content'));
    }
  } catch (error) {
    console.error('Unexpected error in approveContentSaga:', error);
    const errorMessage = error.response?.data?.message || error.message || 'Failed to approve content';
    yield put(approveContentFailure(errorMessage));
  }
}

function* rejectContentSaga(action) {
  try {
    const { contentId, reason } = action.payload;
    
    console.log('Rejecting content:', { contentId, reason });
    
    const endpoint = API_ENDPOINTS.ADMIN.CONTENT_REJECT(contentId);
    const response = yield call(ApiHelper.post, endpoint, { reason });

    console.log('Reject response:', response);

    if (response.success) {
      yield put(rejectContentSuccess(contentId));
      
      const filters = yield select(state => state.contentApproval.filters);
      yield put(fetchPendingContentsRequest(filters));
    } else {
      yield put(rejectContentFailure(response.message || 'Failed to reject content'));
    }
  } catch (error) {
    console.error('Unexpected error in rejectContentSaga:', error);
    const errorMessage = error.response?.data?.message || error.message || 'Failed to reject content';
    yield put(rejectContentFailure(errorMessage));
  }
}

// Root saga - Following college saga pattern
export default function* contentApprovalSaga() {
  yield takeLatest(FETCH_PENDING_CONTENTS_REQUEST, fetchPendingContentsSaga);
  yield takeLatest(APPROVE_CONTENT_REQUEST, approveContentSaga);
  yield takeLatest(REJECT_CONTENT_REQUEST, rejectContentSaga);
}
